import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

// required for AOT compilation
export function translateHttpLoader(http: HttpClient): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(http, [
    { prefix: 'assets/i18n/default_', suffix: '.json' },
    { prefix: 'assets/i18n/banking_', suffix: '.json' },
    { prefix: 'assets/i18n/intlfin_', suffix: '.json' },
  ]);
}
